<template>
    <div class="facts" id="facts">
        <Fact headline="Let Your Concierge Do The Job" leftright="0" icon="icon-explore" desc="Thrilling Sights, top restaurants, the hottest bars and the latest in shopping, tailored exactly to your individual preferences, wherever you go, worldwide. This is the WIZY Travel Kit, your personal City Concierge that perfectly directs you whilst your travels and frees you from extensive travel preparations ahead. " :img="exploreMockup"/>
        <Fact headline="Your Entire Wallet In One App" leftright="1" icon="icon-wallet" desc="Store all your Bonus-, Loyalty- and Mileage-Cards in the WIZY Pocket and enjoy fully automatic reward recognition wherever you pay. Also, keep your sales receipts in the WIZY pocket, fully digitalized and available for automatic tax refund right away." :img="pocketMockup"/>
        <Fact headline="Pay Wherever You Go" leftright="0" icon="icon-credit-card" desc="Enjoy most convenient Tap & Pay right from your Smartphone. Benefit from Mastercard and its millions of acceptance points accross 210 countries worldwide. Pay from your bank account, your Credit Card, PayPal and various additional sources - you decide by just ticking the respective option." :img="paymentMockup"/>
    </div>
</template>


<script>
import Fact from '../components/Fact.vue'

export default {
  name: "Facts",
  props: [],
  components: {
      Fact
  },
  data(){
      return{
          exploreMockup: require('@/assets/exploreMockup.png'),
          pocketMockup: require('@/assets/pocketMockup.png'),
          paymentMockup: require('@/assets/paymentMockup.png')
      }
  }
};
</script>

<style lang="scss" scoped>

</style>
